import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./Ocr.scss";
import MegaHeader from "../MegaHeader";
import { imageUrl } from "../../utils/imagePath";

const Ocr = () => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <MegaHeader />
      <div className="strategy-containerOcr" style={{ backgroundImage: `url(${imageUrl("common", "Ocrbg.png")})` }}>
        <div className="strategy-text-Ocr">
          <h1 className="Airline">AIRLINES</h1>
          <br />
          <img src={imageUrl("ocr-case-study", "ocrbtnbg.png")} alt="h"></img>
        </div>
      </div>

      <div className="row mt-7 px">
        <div className="d-flex">
          <img src={imageUrl("common", "fullscreen.png")} className="mb-2 fullscreen" alt="full-screen" height={20} width={20} 
          onClick={handleShow}
          ></img>
       
        </div>

        <div className="col-lg-12 col-md-12">
          <iframe
            style={{ height: "100vh" }}
            src="https://app-ocr-5fruz6mrkkfozf3wau24ay.streamlit.app/?embedded=true"
            height="100vh"
            width="100%"
            frameBorder="0"
            scrolling="no"
            allowFullScreen
            title="Streamlit App"
          ></iframe>
        </div>
      </div>

      {/* Modal for Streamlit App */}
      <Modal show={showModal} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>Image to Text</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src="https://app-ocr-5fruz6mrkkfozf3wau24ay.streamlit.app/?embedded=true"
            style={{
              height: "80vh",
              width: "100%",
              border: "0",
            }}
            frameBorder="0"
            scrolling="yes"
            allowFullScreen
            title="Streamlit App"
          ></iframe>
        </Modal.Body>
      </Modal>

      {/* Steps involved */}
      <div className="row px mt-7">
        <div className="col-4 " style={{ display: "flex" }}>
          <img src={imageUrl("ocr-case-study", "Group 55.png")} alt="Ai" height={40} width={40}></img>
          <p className="icon-p">
            AI-powered OCR technology that transforms boarding passes into
            instant digital data, streamlining airport check-in processes.
          </p>
        </div>

        <div className="col-4 " style={{ display: "flex" }}>
          <img src={imageUrl("ocr-case-study", "Group 50.png")} alt="Ai" height={40} width={40}></img>
          <p className="icon-p">
            A mobile application that serves as a smart assistant, providing
            staff with immediate access to passenger information across various
            airline formats.
          </p>
        </div>

        <div className="col-4" style={{ display: "flex" }}>
          <img src={imageUrl("ocr-case-study", "Group 51.png")} alt="Ai" height={40} width={40}></img>
          <p className="icon-p">
            Guide airport personnel through efficient data capture, reducing
            queues and enhancing passenger experience in high-traffic
            situations.
          </p>
        </div>
      </div>

      <div className="row px mt-7">
        <div className="col-7">
          <h1 className="industry">Future</h1>
          <p className="application">Applications</p>
          <img src={imageUrl("ocr-case-study", "GenAi1.png")} alt="train" className="w-100"></img>
          <p className="mt-4 normal-22">
            <strong>Revolutionizing the Passenger Journey</strong> - Imagine a
            world where long queues are a thing of the past. Our solution
            slashes wait times, transforming the dreaded check-in process into a
            swift experience. Passengers now glide through airports with a
            smile, setting the stage for their adventures ahead.
          </p>
          <p className="normal-22">
            <strong>Maximizing Staff Potential</strong> - Picture a workforce
            liberated from language barriers and extensive training. Our
            technology empowered the team to perform like seasoned pros from day
            one, drastically cutting costs while skyrocketing efficiency.
          </p>
          <p className="normal-22">
            <strong>Pioneering the Future of Airport Operations</strong> -
            Envision cutting-edge OCR technology nestled in the palm of your
            hand. Experience pinpoint accuracy and lightning-fast data
            management that will leave your competitors in awe and your
            passengers in wonder.
          </p>
        </div>

        <div className="col-5">
          <img src={imageUrl("ocr-case-study", "GenAi2.png")} alt="ny" className="py-2 w-100"></img>
          <img src={imageUrl("ocr-case-study", "GenAi3.png")} alt="nurse" className="py-2 w-100"></img>
          <img src={imageUrl("ocr-case-study", "GenAi4.png")} alt="bus" className="py-2 w-100"></img>
        </div>
      </div>
    </>
  );
};

export default Ocr;
